import React, { useRef } from 'react';
import { Formik } from 'formik';
import { Outlet } from 'react-router-dom';
import { observer } from 'mobx-react';
import { css } from '@emotion/css';
import { initialValues } from '../../validation/initialValues';
import { stepStore } from '../../store/step-store';
import { useWindowSize } from '../../utils/useWindowSize';
import { Header } from '../components/Header';
import { RightSidebar } from '../components/RightSidebar';
import { PolicyDisclaimerText } from '../components/PolicyDisclaimerText';
import { Footer } from '../components/Footer';
import { stateStore } from '../../store/state-store';
import { ProgressBar } from '../components/ProgressBar';
import {AccessibilityContainer} from "../components/AccessibilityContainer";

const bodyStyle = css`
  min-height: calc(100vh - 10px);
  display: grid;
  grid-template-columns: 1fr 3fr 1fr;
  grid-template-rows: 5rem 2rem auto auto;
  grid-template-areas:
    'header header header'
    '. progress info'
    '. main info'
    'footer footer footer';
  background-color: var(--white);
  @media (max-width: 768px) {
    grid-template-areas:
      'header'
      'progress'
      'main'
      'info'
      'footer';
    grid-template-columns: 100%;
    grid-template-rows: auto;
  }
`;

const contentContainer = css`
  grid-area: main;
  display: flex;
  position: relative;
  flex-direction: column;
  @media (max-width: 768px) {
    min-height: calc(100vh - 6rem);
  }
`;

const getValidationScheme = () => {
  const { step } = stepStore;
  return stateStore.stepper[step]?.validation;
};

export const FormikWrapper = observer(() => {
  const formikRef = useRef();
  const windowSize = useWindowSize();
  const { step } = stepStore;

  const handleFormikSubmit = (values, formikBag) => {
    stepStore.nextStep();
    formikBag.setTouched({}, false);
    window.scrollTo(0, 0);
  };
  return (
    <div className={bodyStyle}>
      <Header />
      <ProgressBar />
      <main className={contentContainer}>
        <Formik initialValues={initialValues({})} validationSchema={getValidationScheme} onSubmit={handleFormikSubmit}>
          {formik => {
            formikRef.current = formik;
            return <Outlet />;
          }}
        </Formik>
      </main>
      <AccessibilityContainer/>
      <RightSidebar>{step === 1 && windowSize.width > 768 && <PolicyDisclaimerText />}</RightSidebar>
      <Footer />
    </div>
  );
});
